/**
 * @file    js/global.js
 *
 * copyright (c) 2006-2026 Frank Hellenkamp [jonas@depage.net]
 *
 * @author    Frank Hellenkamp [jonas@depage.net]
 */

import { MagazineNavigator } from '@depage/magaziner';
import { initSlideshows } from "./slideshow";
import { initAntiSpam } from "./email-antispam";
import fitty from "fitty";

import "../sass/global.scss";

var depage = (function() {
    "use strict";
    /*jslint browser: true*/

    // {{{ throttle
    var throttle = function(func, wait) {
        var timeout = null;
        var lastRun = 0;

        var run = function() {
            lastRun = Date.now();
            timeout = null;
            func();
        };

        return function() {
            if (timeout) return;

            var remaining = wait - (Date.now() - lastRun);
            if (remaining <= 0) {
                run();
            }
            else {
                timeout = setTimeout(run, remaining);
            }
        };
    };
    // }}}

    var sidebar;

    // local Project instance that holds all variables and public functions
    var localJS = {
        // {{{ ready
        ready: function() {
            document.documentElement.classList.add("javascript");

            localJS.setupMagaziner();
            localJS.setupNavigation();
            localJS.setupSidebar();
            localJS.setupTeaserClick();

            var body = document.querySelector("body");

            body.addEventListener("depage-preview:updated", function(e) {
                localJS.setup(e.target);
            })

            localJS.setup();
        },
        // }}}
        // {{{ setup
        setup: function(root) {
            if (typeof root == 'undefined') {
                root = document.documentElement;
            }

            localJS.setupVarious(root);
        },
        // }}}
        // {{{ setupTeaserClick
        setupTeaserClick: function() {
            document.addEventListener('click', function(e) {
                var teaser = e.target.closest('.teaser');
                if (!teaser) return;

                var link = teaser.querySelector('a');
                if (!link) return;

                if (e.target.closest('a') === link) return;

                e.preventDefault();
                link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
            });
        },
        // }}}
        // {{{ setupVarious
        setupVarious: function(root) {
            // email antispam
            initAntiSpam(root);

            localJS.setupSlideshows(root);

            fitty(".text.style-fit > h2 > span, .text.style-fit > p");
        },
        // }}}
        // {{{ setupNavigation
        setupNavigation: function() {
            var header = document.querySelector("body > header");

            var setActiveNav = throttle(function() {
                var scrollTop = (window.pageYOffset || document.documentElement.scrollTop);

                if (header) {
                    header.classList.toggle("on-top", scrollTop < 100);
                }
            }, 200);
            window.addEventListener("scroll", setActiveNav);
            setTimeout(setActiveNav, 300);
        },
        // }}}
        // {{{ setupMagaziner
        setupMagaziner: function() {
            var pagecontainer = document.getElementById("pagecontainer");
            var navLinks = document.querySelectorAll("nav.main a");

            var magaziner = new MagazineNavigator(pagecontainer, "nav.main a", {
                preloadPageTimeout: 1000,
            });

            if (!magaziner) return;

            pagecontainer.addEventListener("depage-magaziner:loaded", function(e) {
                var page = e.detail.page;
                localJS.setup(page);
            });
            pagecontainer.addEventListener("depage-magaziner:statechangecomplete", function(e) {
                var url = e.detail.url;
                var currentLink = null;

                document.querySelectorAll("nav.main .active, nav.main .parent-of-active").forEach(function(el) {
                    el.classList.remove("active", "parent-of-active");
                });

                for (var i = 0; i < navLinks.length; i++) {
                    if (navLinks[i].href == url) {
                        currentLink = navLinks[i];
                    }
                }

                if (currentLink) {
                    for (var li = currentLink.closest("li"); li; li = li.parentElement && li.parentElement.closest("li")) {
                        li.classList.add("parent-of-active");

                        var parentLink = li.querySelector(":scope > a");
                        if (parentLink) {
                            parentLink.classList.add("parent-of-active");
                        }
                    }
                    currentLink.classList.add("active");
                }
                if (sidebar) {
                    sidebar.classList.remove("menu-open");
                }
            });
        },
        // }}}
        // {{{ setupSlideshows
        setupSlideshows: function(root) {
            initSlideshows(root, {
                elements: "figure, div",
                speed: 2000,
                pause: 5000
            });
        },
        // }}}
        // {{{ setupSidebar
        setupSidebar: function() {
            sidebar = document.querySelector("nav.sidebar");
            if (!sidebar) return;

            var burgerIcon = sidebar.querySelector(":scope > .burger-icon");
            if (!burgerIcon) return;

            burgerIcon.addEventListener("click", function() {
                sidebar.classList.toggle("menu-open");
            });
        }
        // }}}
    };

    return localJS;
})();

// {{{ register ready event
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() {
        depage.ready();
    });
}
else {
    depage.ready();
}
// }}}

// vim:set ft=javascript sw=4 sts=4 fdm=marker :
